module.exports = __webpack_public_path__ + "img/viime_logo_ko.23e5e833.svg";